// ============================================================================
//  MULTI-LOCATION TEMPLATE CONFIG
//  ---------------------------------------------------------------------------
//  To launch a NEW location, copy one block inside LOCATIONS below and change
//  ONLY these fields:
//    slug             -> the URL path (e.g. "troy"  ->  yoursite.com/troy)
//    spaName          -> Spa / business name
//    promoName        -> Promo treatment name
//    price / regPrice -> Intro price + regular price
//    acuityUrl        -> Acuity Scheduling link (with owner & appointmentType)
//    acuityNotesFieldId -> Acuity intake Field ID (or "" to disable)
//    introVideo       -> { youtubeId, poster } for the "inside the medspa" clip
//    videoTestimonials-> optional per-location testimonial clips
//    cityLine / city / address / nearby / phone -> location details
//  Everything else (design, funnel, reviews, before/after, FAQs) is shared.
// ============================================================================

// ---- Shared placeholder media (override per-location via loc.images if needed)
const IMG = {
  hero: "https://images.unsplash.com/photo-1706795033728-9232ef548a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxhZXN0aGV0aWNpYW4lMjBjbGllbnR8ZW58MHx8fHwxNzg3ODYyMjAxfDA&ixlib=rb-4.1.0&q=85",
  whatYouGet: "https://images.unsplash.com/photo-1782159981479-0fafb56d3cd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxhZXN0aGV0aWNpYW4lMjBjbGllbnR8ZW58MHx8fHwxNzg3ODYyMjAxfDA&ixlib=rb-4.1.0&q=85",
  room: "https://images.unsplash.com/photo-1787651343496-35b3666dd7d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxzcGElMjB0cmVhdG1lbnQlMjByb29tfGVufDB8fHx8MTc4Nzg2MjIwN3ww&ixlib=rb-4.1.0&q=85",
  facial1: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxmYWNpYWwlMjB0cmVhdG1lbnR8ZW58MHx8fHwxNzg3ODYyMjA3fDA&ixlib=rb-4.1.0&q=85",
  facial2: "https://images.unsplash.com/photo-1731514771613-991a02407132?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxmYWNpYWwlMjB0cmVhdG1lbnR8ZW58MHx8fHwxNzg3ODYyMjA3fDA&ixlib=rb-4.1.0&q=85",
};

// ---- Real client before/after composites (shared across locations)
const BEFORE_AFTER = [
  { name: "Barbara L.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/thwu7qwg_Screenshot%202026-08-27%2011.07.28%20PM.png" },
  { name: "Lynette G.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/1rvmqtwt_Screenshot%202026-08-27%2011.07.48%20PM.png" },
  { name: "Suzanne F.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/ou3jgoxn_Screenshot%202026-08-27%2011.08.11%20PM.png" },
  { name: "Janice K.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/6ql0s1lc_Screenshot%202026-08-27%2011.08.56%20PM.png" },
  { name: "Lynn C.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/fwi1t6np_Screenshot%202026-08-27%2011.09.12%20PM.png" },
];

const REVIEWS = [
  { name: "Brittany B", initial: "B", when: "1 month ago", text: "I think I found the Holy Grail — youthful results, great prices, and wonderful client care. Two sessions in and I can already see a difference. Cautiously optimistic!" },
  { name: "Dena Hirsh", initial: "D", when: "1 month ago", text: "I absolutely love the results from my RF treatments to smooth the skin along my neck, face, and jawline. The staff is very knowledgeable and helpful. Highly recommend!" },
  { name: "Lori Matthews", initial: "L", when: "2 months ago", text: "The spa is beautiful, clean, and visually appealing. The team is kind, thoughtful, and amazing. You will be very pleased by the process and outcome!" },
  { name: "Yessy R", initial: "Y", when: "3 weeks ago", text: "My first time here and it's awesome. The staff is really professional and welcoming. This is the beginning of a good change for me." },
  { name: "Kelli Greene", initial: "K", when: "1 month ago", text: "My face looks noticeably brighter, more lifted, and has an overall healthy glow that I could see immediately after the treatment." },
  { name: "Catherine D", initial: "C", when: "2 weeks ago", text: "Radio frequency really helped tighten the skin on my jawline. I'm looking forward to the rest of my treatments. A really good experience!" },
  { name: "Kathleen S", initial: "K", when: "1 month ago", text: "My first experience was excellent. The spa is lovely and the staff welcoming, explaining each step. I highly recommend them." },
  { name: "Retha Hill", initial: "R", when: "3 weeks ago", text: "Always so nice. Very relaxing, professional and cheerful. I look forward to every visit." },
];

const HERO_BULLETS = [
  "Visibly lift sagging cheeks, jawline and neck in your first visit",
  "See proven results, even from your first session",
  "Smooth fine lines — no surgery, no fillers, no needles",
  "Walk in. Walk out. Zero downtime.",
  "Comfortable, drug-free, no injections",
];

const QUIZ_STEPS = [
  {
    key: "area",
    question: "Which area particularly bothers you?",
    options: ["Double chin", "Sagging jawline / jowls", 'Loose "turkey neck" skin', "Neck lines & wrinkles", "Everything above"],
  },
  {
    key: "results",
    question: "Our clients usually see these results after a few sessions. Do you want the same?",
    // Shared before/after result image shown on Q2 (applies to all locations)
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/nvde9mnt_Screenshot%202026-08-27%2011.06.46%20PM.png",
    options: ["Yes, I want these results", "No, I don't want to see results"],
  },
  {
    key: "budget",
    question: "Your first session is $179 (regular $500). Are you ready to invest that in yourself?",
    options: ["Yes, I'm ready ($179 is fine)", "No, I don't have the money to invest in myself"],
  },
  {
    key: "timing",
    question: "When do you want to come in?",
    options: ["Now / this week", "In 2-3 weeks", "Just looking for now"],
  },
];

const DISQUALIFY = {
  budget: "No, I don't have the money to invest in myself",
  timing: "Just looking for now",
};

const DISQUALIFIED_MESSAGE = {
  headline: "Unfortunately, it looks like you are not trying to get started right now.",
  body: "If we made the wrong call, go here and book your appointment",
  cta: "\uD83D\uDC49 Book here",
};

// ============================================================================
//  LOCATIONS  — add a new object here to launch a new location page
// ============================================================================
export const DEFAULT_SLUG = "clinton-twp";

export const LOCATIONS = {
  "clinton-twp": {
    slug: "clinton-twp",
    spaName: "Descent Medical Spa",
    legalName: "Iridescent Medical Spa",
    brandAccent: "Medical Spa", // portion of the name shown in accent color
    promoName: "3-In-1 Non-Surgical Face Lift",
    promoShort: "3-In-1 Face Lift",
    price: 179,
    regPrice: 500,
    duration: "75-min session",
    durationLabel: "75-minute",
    acuityUrl: "",
    acuityNotesFieldId: "3364857",
    metaPixelId: "",
    introVideo: { youtubeId: "ScMzIvxBSi4", poster: IMG.room },
    cityLine: "Clinton Township, Michigan",
    city: "Clinton Township",
    region: "Metro Detroit",
    address: "42855 Garfield Rd. 105, Clinton Twp, MI 48038",
    nearby: "Sterling Heights, Macomb, Warren, and surrounding Metro Detroit",
    phone: "(586) 555-0142",
    hours: "Mon–Sat, 9am–6pm",
    rating: "4.9",
    reviewCount: "120+",
    spotsLeft: 15,
  },

  "thebeautyspot5-in-1": {
    slug: "thebeautyspot5-in-1",
    spaName: "The Beauty Spot Tampa",
    legalName: "Alba Team, LLC DBA The Beauty Spot Tampa",
    brandAccent: "Tampa",
    promoName: "5 in 1 Lift & Glow Facial Treatment",
    promoShort: "5-in-1 Lift & Glow",
    price: 69,
    regPrice: 349,
    deposit: 15,
    duration: "45-min session",
    durationLabel: "45-minute",
    acuityUrl: "https://app.acuityscheduling.com/schedule.php?owner=40256384&appointmentType=97644389",
    acuityNotesFieldId: "3365196",
    metaPixelId: "1712440419987531",
    crmLeadUrl: "https://lead-manager-194.emergent.host/api/public/leads/6a91d59d0987f81b59e83acb",
    crmSecret: "eUjjBt0yC0e_0gf8XS9tREv9",
    crmSource: "The Beauty Spot Tampa",
    ghlChatWidgetId: "6a9338ee6587870a7b808ea0",
    hidePhoneField: true,
    introVideo: { videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/9grpojmg_output%20%2811%29.mp4", poster: IMG.room },
    cityLine: "Tampa, Florida",
    city: "Tampa",
    region: "Tampa Bay",
    address: "6521 Gunn Hwy, Tampa, FL 33625",
    nearby: "Carrollwood, Citrus Park, Westchase, and the greater Tampa Bay area",
    phone: "813-540-7146",
    hours: "Mon–Thu 11–7 · Fri 10–6 · Sun 11–6 (Sat closed)",
    rating: "4.9",
    reviewCount: "120+",
    spotsLeft: 15,
  },

  "tampa3dlift": {
    slug: "tampa3dlift",
    spaName: "The Beauty Spot Tampa",
    legalName: "Alba Team, LLC DBA The Beauty Spot Tampa",
    brandAccent: "Tampa",
    promoName: "3D Natural Facelift",
    promoShort: "3D Natural Facelift",
    price: 97,
    regPrice: 449,
    noDeposit: true,
    contactFirst: true,
    quizKeys: ["area", "results"],
    duration: "45 minutes + consultation",
    durationLabel: "45-minute",
    acuityUrl: "https://app.acuityscheduling.com/schedule.php?owner=40256384&appointmentType=97753066",
    ghlCalendarUrl: "https://api.leadconnectorhq.com/widget/booking/tg5fOZ5yFKALzzEyYAdE",
    acuityNotesFieldId: "3367319",
    metaPixelId: "1712440419987531",
    crmLeadUrl: "https://lead-manager-194.emergent.host/api/public/leads/6a91d59d0987f81b59e83acb",
    crmSecret: "eUjjBt0yC0e_0gf8XS9tREv9",
    crmSource: "The Beauty Spot Tampa — 3D Natural Facelift",
    introVideo: { videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_revitalize-glendale/artifacts/9grpojmg_output%20%2811%29.mp4", poster: IMG.room },
    heroTitleA: "Lift, Tighten & Smooth Your Face",
    heroTitleItalic: "Naturally",
    heroBullets: [
      "Step 1 — Deep cleanse + light exfoliation",
      "Step 2 — Red light therapy for radiance",
      "Step 3 — EMS muscle lifting & firming",
      "Step 4 — Warming peptide mask infusion",
      "No surgery, no needles, no downtime",
    ],
    treatmentDescription: "A four-step facelift in one relaxing session: (1) a gentle cleanse and light exfoliation to prep the skin, (2) red light therapy to boost radiance, (3) EMS muscle stimulation to lift and firm, then (4) a warming peptide mask infusion to deeply nourish and smooth.",
    howItWorksHeading: "Four steps. One natural lift.",
    offerMainInclude: "3D Natural Facelift Session — Cleanse + Red Light + EMS Lift + Peptide Mask ($449 value)",
    faqWhatIs: "A 45-minute, four-step facelift: (1) cleanse + light exfoliation, (2) red light therapy, (3) EMS muscle lifting and firming, and (4) a warming peptide mask infusion. No surgery, no needles — with results you can start to see after your first visit.",
    cityLine: "Tampa, Florida",
    city: "Tampa",
    region: "Tampa Bay",
    address: "6521 Gunn Hwy, Tampa, FL 33625",
    nearby: "Carrollwood, Citrus Park, Westchase, and the greater Tampa Bay area",
    phone: "813-540-7146",
    hours: "Mon–Thu 11–7 · Fri 10–6 · Sun 11–6 (Sat closed)",
    rating: "4.9",
    reviewCount: "120+",
    spotsLeft: 15,
  },

  "ClintonTwp-CryoNeck": {
    slug: "ClintonTwp-CryoNeck",
    spaName: "Descent Medical Spa",
    legalName: "Iridescent Medical Spa",
    brandAccent: "Medical Spa",
    promoName: "Cryo Neck Lift with Advanced Hyaluronic Acid and Peptide Mask",
    promoShort: "Cryo Neck Lift",
    price: 99,
    regPrice: 399,
    deposit: 20,
    duration: "30-min session + consultation",
    durationLabel: "30-minute",
    acuityUrl: "https://app.acuityscheduling.com/schedule.php?owner=40137040&appointmentType=97615167",
    acuityNotesFieldId: "3365967",
    metaPixelId: "",
    heroTitleA: "Lift & Sculpt Your Neck & Jawline",
    heroTitleItalic: "Without Surgery",
    heroSubtitle: "Controlled cool temperatures target the saggy neck and jawline, then our signature Peptide Mask smooths neck lines and wrinkles — with results you can start to see after your first visit.",
    treatmentDescription: "This treatment uses controlled cool temperatures to target the saggy neck and jawline, then our signature Peptide Mask helps reduce neck lines and wrinkles — with results you can start to see even after your first visit.",
    faqWhatIs: "A 30-minute Cryo Neck Lift that uses controlled cool temperatures to target the saggy neck and jawline, followed by our signature Advanced Hyaluronic Acid and Peptide Mask to reduce neck lines and wrinkles. No surgery, no needles — with results you can start to see even after your first visit.",
    howItWorksHeading: "Controlled cooling + signature peptide mask.",
    offerMainInclude: "Cryo Neck Lift + Advanced Hyaluronic Acid & Peptide Mask Session ($399 value)",
    introVideo: { youtubeId: "ScMzIvxBSi4", poster: IMG.room },
    cityLine: "Clinton Township, Michigan",
    city: "Clinton Township",
    region: "Metro Detroit",
    address: "42855 Garfield Rd. 105, Clinton Twp, MI 48038",
    nearby: "Sterling Heights, Macomb, Warren, and surrounding Metro Detroit",
    phone: "586.690.8693",
    hours: "Tue, Fri, Sat 10–7 · Wed, Thu 10–5",
    rating: "4.9",
    reviewCount: "120+",
    spotsLeft: 15,
  },

  // ---- EXAMPLE second location (edit the fields, then visit /troy) ----------
  // "troy": {
  //   slug: "troy",
  //   spaName: "Descent Medical Spa",
  //   brandAccent: "Medical Spa",
  //   promoName: "3-In-1 Non-Surgical Face Lift",
  //   promoShort: "3-In-1 Face Lift",
  //   price: 179,
  //   regPrice: 500,
  //   duration: "75-min session",
  //   durationLabel: "75-minute",
  //   acuityUrl: "https://app.acuityscheduling.com/schedule.php?owner=XXXXX&appointmentType=YYYYY",
  //   acuityNotesFieldId: "",
  //   introVideo: { youtubeId: "YOUR_YT_ID", poster: IMG.room },
  //   cityLine: "Troy, Michigan",
  //   city: "Troy",
  //   region: "Oakland County",
  //   address: "123 Big Beaver Rd, Troy, MI 48084",
  //   nearby: "Birmingham, Rochester, Sterling Heights, and surrounding Oakland County",
  //   phone: "(248) 555-0100",
  //   hours: "Mon–Sat, 9am–6pm",
  //   rating: "4.9",
  //   reviewCount: "120+",
  //   spotsLeft: 15,
  // },
};

// ---- Pick the active location from the URL path (e.g. /clinton-twp) ---------
export function getActiveSlug() {
  if (typeof window === "undefined") return DEFAULT_SLUG;
  const seg = window.location.pathname.replace(/^\/+|\/+$/g, "").split("/")[0];
  return LOCATIONS[seg] ? seg : DEFAULT_SLUG;
}

// ---- Build the full content object for a given location ---------------------
export function buildConfig(loc) {
  const dur = loc.durationLabel || "75-minute";
  const deposit = loc.deposit ?? 30;
  const durMinutes = dur.replace("-minute", " minutes");
  // Per-page copy (falls back to the default 3-in-1 face-lift wording)
  const treatmentDesc =
    loc.treatmentDescription ||
    "Three technologies, one visit. Radio-frequency skin tightening, micro-lifting, and collagen stimulation work together across the lower face, jawline, and neck.";
  const howItWorksHeading = loc.howItWorksHeading || "Three technologies. One visit.";
  const offerMainInclude =
    loc.offerMainInclude || `${loc.promoName} Session — RF + Micro-Lifting + Collagen ($${loc.regPrice} value)`;
  const faqWhatIs =
    loc.faqWhatIs ||
    `A ${dur} face-and-neck lift that stacks three technologies: radio-frequency skin tightening, micro-lifting, and collagen stimulation. They firm the skin, redefine the jawline, and smooth lines. No surgery, no needles.`;
  return {
    BUSINESS: {
      name: loc.spaName,
      accent: loc.brandAccent || "",
      monogram: loc.spaName.trim().charAt(0).toUpperCase(),
      city: loc.city,
      region: loc.region,
      address: loc.address,
      phone: loc.phone,
      hours: loc.hours,
      rating: loc.rating,
      reviewCount: loc.reviewCount,
      spotsLeft: loc.spotsLeft,
      announcement: `Only ${loc.spotsLeft} ${loc.city} spots this week`,
    },
    ACUITY_URL: loc.acuityUrl,
    GHL_CALENDAR_URL: loc.ghlCalendarUrl || "",
    GHL_CHAT_WIDGET_ID: loc.ghlChatWidgetId || "",
    HIDE_PHONE_FIELD: !!loc.hidePhoneField,
    ACUITY_NOTES_FIELD_ID: loc.acuityNotesFieldId || "",
    META_PIXEL_ID: loc.metaPixelId || "",
    CRM_LEAD_URL: loc.crmLeadUrl || "",
    CRM_SOURCE: loc.crmSource || loc.spaName,
    CRM_SECRET: loc.crmSecret || "",
    LEGAL_NAME: loc.legalName || loc.spaName,
    PRIVACY_EMAIL: loc.privacyEmail || "privacy@clinic-book.com",
    NO_DEPOSIT: !!loc.noDeposit,
    CONTACT_FIRST: !!loc.contactFirst,
    DIRECT_BOOKING: !!loc.directBooking,
    OFFER: {
      name: loc.promoName,
      price: loc.price,
      regPrice: loc.regPrice,
      deposit: deposit,
      currency: "USD",
      duration: loc.duration,
      durationLabel: dur,
      includedCount: 3,
    },
    COUNTDOWN_MINUTES: loc.countdownMinutes ?? 15,
    HERO: {
      eyebrow: loc.cityLine,
      titleA: loc.heroTitleA || "Lift, Tighten & Smooth Your Face",
      titleItalic: loc.heroTitleItalic || "Without Surgery",
      priceLine: `Reserve Your ${loc.promoShort || loc.promoName} For Just`,
      subtitle:
        loc.heroSubtitle ||
        `Visibly lift and firm your face in your first ${dur} visit. No surgery. No needles. No downtime.`,
      bullets: loc.heroBullets || HERO_BULLETS,
      image: loc.images?.hero || IMG.hero,
    },
    WHAT_YOU_GET: {
      title: loc.promoName,
      bullets: loc.heroBullets || HERO_BULLETS,
      image: loc.images?.whatYouGet || IMG.whatYouGet,
    },
    BEFORE_AFTER,
    INTRO_VIDEO: loc.introVideo,
    VIDEO_TESTIMONIALS: loc.videoTestimonials || [],
    REVIEWS,
    HOW_IT_WORKS_HEADING: howItWorksHeading,
    HOW_IT_WORKS: [
      { step: "01", title: "Personalized Skin Assessment", text: "Your aesthetician reviews the skin on your cheeks, jawline, and neck. You talk through what's bothering you and she tailors the plan to your skin. Free with your first visit (usually $75)." },
      { step: "02", title: loc.promoName, text: treatmentDesc },
      { step: "03", title: "Custom Treatment Plan", text: "Your aesthetician writes a follow-up plan for your skin and goals — so the lift holds long-term." },
    ],
    WHO_WE_ARE: {
      title: "Who We Are",
      subtitle: `A patient-focused, results-driven medical spa serving ${loc.city} & ${loc.region}`,
      text: `${loc.spaName} is a results-driven practice built around one thing: real, visible outcomes for our patients. Our team of licensed aestheticians follows proven, protocol-based treatment plans and uses advanced, clinical-grade technology to deliver consistent results at scale — every treatment performed in a private room and tailored to your goals.`,
      bullets: [
        "Licensed aestheticians and proven, protocol-based treatment plans",
        "Advanced, clinical-grade technology for consistent, measurable results",
        "Your own private treatment room — focused, one-on-one care",
        "Personalized plans built around your goals and long-term results",
        `${loc.rating}\u2605 across ${loc.reviewCount} Google reviews — read them yourself`,
      ],
      image: loc.images?.room || IMG.room,
    },
    TREATMENT_IMAGES: loc.images?.treatment || [IMG.facial1, IMG.facial2, IMG.whatYouGet],
    OFFER_INCLUDES: [
      "Personalized Face & Neck Skin Assessment ($75 value)",
      offerMainInclude,
      "Custom Multi-Session Treatment Plan ($50 value)",
    ],
    FAQS: [
      loc.noDeposit
        ? { q: "Do I need to pay anything to book?", a: `No deposit and no payment required — booking is completely free. Just pick your time and show up. Your first session is $${loc.price} (regular $${loc.regPrice}), paid at your visit.` }
        : { q: `What's the $${deposit} deposit for?`, a: `It's a refundable hold to lock in your spot. It comes off the $${loc.price} price at your visit — so you only pay $${loc.price - deposit} more on the day. Reschedule with 24 hours' notice and the deposit moves to your new date. Cancel and we refund it.` },
      { q: "What happens after I book?", a: "You'll get an SMS and email confirming your slot. We don't chase you — no pitch. Just show up at your appointment." },
      { q: `What exactly is the ${loc.promoShort || loc.promoName}?`, a: faqWhatIs },
      { q: "How long is the appointment?", a: `${durMinutes} total — that includes your skin assessment, the full session, and a few minutes after to walk through your follow-up plan.` },
      { q: "Will I see results after the first session?", a: "Most clients see visible lifting and tightening across the cheeks, jawline, and neck, with results continuing to develop as collagen rebuilds. Individual results vary." },
      { q: "Is this the same as a surgical facelift?", a: "No. This isn't surgery — no cuts, no anesthesia, no recovery. It builds your own collagen to lift and tighten over time. Most clients see real, visible firming." },
      { q: "Does it hurt?", a: "No. Most clients say it feels warm and comfortable, like a facial with a lift. The handpiece glides across your skin — nothing sharp, nothing painful." },
      { q: "Will my skin be red or peel afterwards?", a: "You may have mild warmth or slight redness for a couple of hours, then it settles. You can go straight back to work and wear makeup the same day." },
      { q: "Who shouldn't get this treatment?", a: "Skip this one if you have a pacemaker, metal implants in the head/neck area, an active skin infection, recent facial surgery, or you're pregnant. If unsure, mention it when you book and we'll check with your aesthetician first." },
      { q: "How should I prepare?", a: "Come with a clean face — no heavy makeup, lotions, or oils. Drink plenty of water. Skip tanning, retinol, and chemical peels on the face and neck for 48 hours beforehand." },
      { q: "Where are you located?", a: `${loc.address}. Easy from ${loc.nearby}. Free parking right outside the suite.` },
    ],
    QUIZ_STEPS: QUIZ_STEPS.map((s) =>
      s.key === "budget"
        ? {
            ...s,
            question: `Your first session is $${loc.price} (regular $${loc.regPrice}). Are you ready to invest that in yourself?`,
            options: [
              `Yes, I'm ready ($${loc.price} is fine)`,
              `I'm not ready to invest $${loc.price} in myself at this time`,
            ],
          }
        : s
    ).filter((s) => !loc.quizKeys || loc.quizKeys.includes(s.key)),
    DISQUALIFY: {
      ...DISQUALIFY,
      budget: `I'm not ready to invest $${loc.price} in myself at this time`,
    },
    DISQUALIFIED_MESSAGE,
  };
}

export function getActiveConfig() {
  return buildConfig(LOCATIONS[getActiveSlug()]);
}

// ---- Generic nationwide root page ("/") — no branding/logos ----------------
export const NATIONAL = {
  eyebrow: "Locations Nationwide",
  title: "Book Your Treatment",
  subtitle:
    "We have locations nationwide. Share your details and your zip code, and we'll reach out to confirm your nearest location and get you booked in.",
  bullets: [
    "Advanced, non-surgical aesthetic treatments",
    "Trusted, licensed providers at every location",
    "Fast confirmation from the team closest to you",
  ],
  image:
    "https://images.unsplash.com/photo-1706795033728-9232ef548a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxhZXN0aGV0aWNpYW4lMjBjbGllbnR8ZW58MHx8fHwxNzg3ODYyMjAxfDA&ixlib=rb-4.1.0&q=85",
};

